import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { ProgressProvider } from "./context/ProgressContext";
import { Header } from "./components/Header";
import Home from "./pages/Home";
import Module from "./pages/Module";
import Badges from "./pages/Badges";
import Leaderboard from "./pages/Leaderboard";

function AppLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <footer className="border-t border-border">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex items-center justify-between text-xs font-mono-code text-muted-foreground">
          <span>PROMPT CRAFT · MICRO LEARNING · 2026</span>
          <span>evaluated by claude sonnet 4.5</span>
        </div>
      </footer>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <ProgressProvider>
        <BrowserRouter>
          <AppLayout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/module/:moduleId" element={<Module />} />
              <Route path="/badges" element={<Badges />} />
              <Route path="/leaderboard" element={<Leaderboard />} />
            </Routes>
          </AppLayout>
          <Toaster position="top-right" theme="light" richColors />
        </BrowserRouter>
      </ProgressProvider>
    </div>
  );
}

export default App;
